import React, { useState } from 'react';

import { User } from '#app/Common/UserCommon';
import LoginForm from '#app/View/Authentication/Login/components/Form';
import LoginFormShop from '#app/View/Authentication/Login/components/FormShop';
import LoginFormLayout from '#app/View/Authentication/Login/components/LoginFormLayout';

const Login: React.FC = () => {
  const [user, setUser] = useState<User>();

  return (
    <LoginFormLayout>
      {!user && <LoginForm setUser={(user) => setUser(user)} />}
      {user && <LoginFormShop user={user} />}
    </LoginFormLayout>
  );
};

export default Login;
